import Input, { PasswordInput } from './Input'

export default Input
export { PasswordInput }
